Directives.SimpleChatDirective = function SimpleChatDirective() {

    // @ngInject
    function SimpleChatDirectiveControllerFunc($timeout,$scope, $injector, $element, ConversationService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'SimpleChatDirectiveController';
        this.$timeout = $timeout;

        var bodyElement = $element.find('.simple-chat-body');
        ConversationService.on('new_message_added', function messageAdded(conversationId){

            if(conversationId == this.conversationId){

                if(Math.abs(bodyElement.prop('scrollTop') - (bodyElement.prop('scrollHeight') - bodyElement.prop('offsetHeight'))) < 5){
                    $timeout(function timedOut(){
                        this.scrollToBottom();
                    }.bind(this), 60);
                }

            }
        }.bind(this));

        ConversationService.on('updateCommunityFeedConversationId', function chatOpenned(conversationId){
            if(conversationId === this.conversationId){
                $timeout(function timedOut(){
                    this.scrollToBottom();
                }.bind(this), 60);
            }
        }.bind(this));

        function SimpleChatConfig() {
            this.showUserAvatar = true;
            this.showCurrentUserAvatar = false;
            this.showComposer = true;
            this.liveMode = false;
            this.showBubbleInfos = true;
        }

        SimpleChatConfig.prototype.setShowUserAvatar = function(value) {
            this.showUserAvatar = value;
        };

        SimpleChatConfig.prototype.setShowCurrentUserAvatar = function(value) {
            this.showCurrentUserAvatar = value;
        };

        SimpleChatConfig.prototype.setShowComposer = function(value) {
            this.showComposer = value;
        };

        SimpleChatConfig.prototype.setLiveMode = function(value) {
            this.liveMode = value;
        };

        SimpleChatConfig.prototype.setShowBubbleInfos = function(value) {
            this.showBubbleInfos = value;
        };

        this.options = new SimpleChatConfig();

        if (angular.isDefined(this.showUserAvatar)) {
            this.options.setShowUserAvatar(this.showUserAvatar);
        }
        if (angular.isDefined(this.showCurrentUserAvatar)) {
            this.options.setShowCurrentUserAvatar(this.showCurrentUserAvatar);
        }
        if (angular.isDefined(this.showComposer)) {
            this.options.setShowComposer(this.showComposer);
        }
        if (angular.isDefined(this.showBubbleInfos)) {
            this.options.setShowBubbleInfos(this.showBubbleInfos);
        }
        if (angular.isDefined(this.liveMode)) {
            this.options.setLiveMode(this.liveMode);
        }

    }

    var SimpleChatDirectiveController = Class(Controllers.BaseController, {
        constructor: SimpleChatDirectiveControllerFunc,

        sendMessage: function sendMessage(message){
            this.sendFunction({message: message});
        }

    });

    function link(scope, element, attrs, ctrl) {
        var queryResult = element[0].getElementsByClassName('js-simple-chat-body');
        var $simpleChatBody = angular.element(queryResult)[0],
            scrollToBottom = function() {
                $simpleChatBody.scrollTop = $simpleChatBody.scrollHeight;
            };

            ctrl.scrollToBottom = scrollToBottom;

        scope.$on('simple-chat-message-posted', function() {
            scope.simpleChatVm.$timeout(scrollToBottom, 0);
        });

        var unbindWatchCollection = scope.$watchCollection(function() {
            return scope.simpleChatVm.messages;
        }, function(newVal, oldVal) {

            if((!oldVal || oldVal.length === 0) && (newVal && newVal.length > 0)){
                scope.simpleChatVm.$timeout(scrollToBottom, 0);
            }

            if(newVal && newVal.length > 0){
                unbindWatchCollection();
            }
        });

        if (angular.isDefined(ctrl.messages) && ctrl.messages.length > 0) {
            scope.simpleChatVm.$timeout(scrollToBottom, 0);
        }

        if (angular.isUndefined(ctrl.messages)) {
            ctrl.messages = [];
        }
    }

    return {
        controller: SimpleChatDirectiveController,
        bindToController: true,
        controllerAs: 'simpleChatVm',
        link: link,
        restrict: 'AE',
        templateUrl: 'angular/app/modules/core/features/chat/simple-chat/simple_chat_directive_template.html',
        scope: {
            messages: '=',
            localUser: '=',
            sendFunction: '&',
            showUserAvatar: '=',
            showCurrentUserAvatar: '=',
            showComposer: '=',
            showBubbleInfos: '=',
            sendButtonText: '@',
            composerPlaceholderText: '@',
            liveMode: '=',
            liveFlagFunction: '=',
            otherUser: '=',
            loadEarlierMessages: '&',
            earlierMessagesAvailable: '=',
            loadingMessages: '=',
            isLiveChat: '=',
            conversationId: '='
        }
    };
};
